
<template>

  <div class="ui result inverted segment" :class="[!work.concluded ? 'primary' : 'secondary']">

    <!-- Continuing -->
    <WorkItem v-if="!work.concluded && !work.khatma" :work="work" :currentTime="currentTime" />
    <KhatmaItem v-else-if="!work.concluded" :khatma="work" />

    <!-- Concluded -->
    <WorkItem v-else-if="!work.khatma" :work="work" />
    <KhatmaItem v-else :khatma="work" />

    <!-- Work participation segment -->
    <SingleParticipation v-if="!work.concluded && !work.khatma && work.length === 'long'" :work="work" />
    <CumulativeParticipation v-else-if="!work.concluded && !work.khatma && work.length === 'short'" :work="work" />

    <!-- Khatma participation segment -->
    <div v-else-if="!work.concluded" class="ui center aligned inverted primary segment">
      <div class="ui centered grid">
        <div class="row">
          <div class="column" style="padding: 0 0 0 3px;">
            <button class="ui fluid yellow button" @click="openKhatma(work.id)">
              <span class="ui almarai large text">شارك في الختمة</span>
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import WorkItem from '@/components/Works/WorkItem';
import SingleParticipation from '@/components/Works/SingleParticipation';
import CumulativeParticipation from '@/components/Works/CumulativeParticipation';

import KhatmaItem from '@/components/Khatmat/KhatmaItem';

export default {

  name: 'Item',
  components: {

    WorkItem,
    SingleParticipation,
    CumulativeParticipation,

    KhatmaItem

  },
  props: {

    work: Object,
    currentTime: Date

  },
  methods: {

    openKhatma(khatmaID) {

      window.location = `/khatmat/${khatmaID}`;

    }

  }

}
</script>

<style scoped>
.result.segment:nth-child(2) {
  border-top: none !important;
}

.white {
  color: white !important;
}
</style>
